import React, { useState } from 'react';
import { Card, Collapse, IconButton, Typography } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const UnprocessedItemsPanel = ({
  title,
  description,
  items,
  collapsible = false,
  defaultCollapsed = false,
  collapsedTitle,
  actionButton,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  if (!items || items.length === 0) {
    return null;
  }

  const headerLabel = collapsible && collapsed ? (collapsedTitle || title) : title;

  return (
    <Card style={{ padding: 16 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: collapsible && collapsed ? 0 : 4,
          cursor: collapsible ? 'pointer' : 'default',
        }}
        onClick={collapsible ? () => setCollapsed((v) => !v) : undefined}
      >
        <Typography variant='h6' style={{ fontFamily: 'Rubik' }}>
          {headerLabel}
        </Typography>
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 8 }}
          onClick={(e) => e.stopPropagation()}
        >
          {actionButton}
          {collapsible && (
            <IconButton
              size='small'
              aria-label={collapsed ? 'Expand' : 'Collapse'}
              onClick={() => setCollapsed((v) => !v)}
            >
              {collapsed ? <ExpandMore /> : <ExpandLess />}
            </IconButton>
          )}
        </div>
      </div>
      <Collapse in={!collapsible || !collapsed} timeout='auto' unmountOnExit>
        {description && (
          <Typography
            variant='body2'
            color='textSecondary'
            style={{ fontFamily: 'Rubik', marginBottom: 12 }}
          >
            {description}
          </Typography>
        )}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
            fontFamily: 'Rubik',
          }}
        >
          {items.map((item) => (
            <div
              key={item.label}
              style={{
                display: 'inline-flex',
                alignItems: 'baseline',
                gap: 6,
                padding: '6px 12px',
                backgroundColor: '#EEF1F5',
                borderRadius: 4,
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              <span style={{ fontWeight: 600 }}>{Number(item.count).toLocaleString()}</span>
              <span style={{ color: '#5C6473' }}>{item.label}</span>
            </div>
          ))}
        </div>
      </Collapse>
    </Card>
  );
};

export default UnprocessedItemsPanel;
